export enum GAMES_CATEGORIES {
    SLOTS = 'slots',
    CARD_AND_TABLE = 'card-and-table',
    LIVE = 'live'
};
